<template>
	<ul v-if="data" class="g-timeline">
		<li v-for="(item, i) in data" :key="i" class="item">
			<span class="date">{{item.date}}</span>
			<p>{{item.content}}</p>
			<div v-if="item.reject" class="reject">{{item.reject}}</div>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			data: [Array, String, Number]
		}
	}
</script>

<style lang="stylus" scoped>
	.g-timeline {
		padding-left: 190px;
		
		li {
			position: relative;
			border-left: 1px solid #eee;
			padding: 3px 0 3px 20px;
			
			&:nth-last-child(1) {
				&:before {
					border-color: #1492FF;
				}
				
				.date {
					color: #000;
				}
			}
			
			&:before {
				content: '';
				position: absolute;
				left: -5px;
				top: 16px;
				width: 9px;
				height: 9px;
				border: 2px solid #ddd;
				border-radius: 100%;
				background: #fff;
			}
			
			.date {
				position: absolute;
				right: 100%;
				top: 0;
				margin-right: 20px;
				line-height: 40px;
				font-size: 15px;
				white-space: nowrap;
				color: #999;
			}
			
			p {
				line-height: 34px;
				font-size: 15px;
				color: #000;
			}
			
			.reject {
				padding: 10px 12px;
				line-height: 24px;
				font-size: 15px;
				color: #E63633;
				background: #FAFAFA;
			}
		}
	}
</style>
